import React from "react"
import { FirebaseAuth } from "react-firebaseui"
import firebase from "firebase"
import "./SignIn.css"

const uiConfig = {
	// Popup signin flow rather than redirect flow.
	signInFlow: "popup",
	// Redirect to /signedIn after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
	signInSuccessUrl: "/",
	// We will display Google and Facebook as auth providers.
	signInOptions: [
		firebase.auth.GoogleAuthProvider.PROVIDER_ID,
		firebase.auth.EmailAuthProvider.PROVIDER_ID,
	],
}

export default function SignIn() {
	return (
		<section>
			<h1 className="sign-in-h1">Sign in</h1>
			<h4 className="sign-in-h1">to Crypto Portfolio Tracker</h4>
			<FirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()} />
		</section>
	)
}



// WEBPACK FOOTER //
// ./src/SignIn.js